import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import styles from "./weekly-templates.module.css"

@tagName("")
export default class WeeklyTemplates extends Component {
  readonly styles = styles
  changeTemplate!: Function
  assignBlankTemplateToRotationDay!: Function

  menuConstraints = [{ to: "window", pin: ["left", "bottom"] }]
  changeMenuForRotation = null

  @action
  openChangeMenu(rotationId) {
    this.set("changeMenuForRotation", rotationId)
  }

  @action
  closeChangeMenu() {
    this.set("changeMenuForRotation", null)
  }

  @action
  toggleChangeMenu(rotationId) {
    if (this.changeMenuForRotation === null) {
      this.set("changeMenuForRotation", rotationId)
    } else {
      this.set("changeMenuForRotation", null)
    }
  }

  @action
  selectOption(option) {
    this.changeTemplate(option)
    this.set("changeMenuForRotation", null)
  }

  @action
  assignBlankTemplateToDay(courseDate, templateId) {
    this.assignBlankTemplateToRotationDay(courseDate, templateId)
  }
}
